import React from "react";

/**
 * Loading placeholder matching the OffCampusRequestForm layout — title, the paired internship fields
 * (company / role, then the company website, location / stipend, start / end), mode, the IRF document and
 * offer letter uploads and a full-width submit — so the swap to the real form does not reflow the page.
 */
const OffCampusRequestSkeleton = (): JSX.Element => (
  <div className="min-h-screen bg-neutral-2 px-4 py-6">
    <div className="mx-auto flex w-full max-w-2xl animate-pulse flex-col gap-6 rounded-2xl bg-white p-5 shadow-sm sm:p-8">
      <div className="flex flex-col gap-2">
        <div className="h-6 w-56 rounded bg-neutral-4" />
        <div className="h-4 w-72 max-w-full rounded bg-neutral-3" />
      </div>

      {[0, 1, 2].map(row => (
        <React.Fragment key={row}>
          <div className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
            {[0, 1].map(cell => (
              <div key={cell}>
                <div className="mb-2 h-4 w-28 rounded bg-neutral-5" />
                <div className="h-10 w-full rounded-lg bg-neutral-4" />
              </div>
            ))}
          </div>
          {/* The company website, on its own row under company / role. */}
          {row === 0 && (
            <div>
              <div className="mb-2 h-4 w-32 rounded bg-neutral-5" />
              <div className="h-10 w-full rounded-lg bg-neutral-4" />
            </div>
          )}
        </React.Fragment>
      ))}

      <div>
        <div className="mb-2 h-4 w-20 rounded bg-neutral-5" />
        <div className="h-10 w-full rounded-lg bg-neutral-4" />
      </div>

      <div className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2">
        {[0, 1].map(cell => (
          <div key={cell}>
            <div className="mb-2 h-4 w-32 rounded bg-neutral-5" />
            <div className="h-10 w-36 rounded-lg bg-neutral-4" />
          </div>
        ))}
      </div>

      <div className="h-10 w-full rounded-md bg-neutral-4" />
    </div>
  </div>
);

export default OffCampusRequestSkeleton;
